<template>
  <div id="chart">
    <apexchart type="bar" height="350" :options="chartOptions" :series="series" />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts"
import { getActivitiesCounts, getActivitiesProviders, topTenActivities } from "../databaseRequests"

// Call for initial data
var providers = getActivitiesProviders()
var counts = getActivitiesCounts()
var labels = topTenActivities

export default {
  name: "BarGroup",
  components: {
    apexchart: VueApexCharts
  },
  data: function() {
    return {
      series: [
        {
          name: "Providers' Companies",
          data: providers
        },
        {
          name: "All Companies",
          data: counts
        }
      ],
      chartOptions: {
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              position: "top"
            }
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 1
        },
        xaxis: {
          categories: labels
        }
      }
    }
  }
}
</script>

<style scoped></style>
